module.exports = __webpack_public_path__ + "static/media/Outdoor Readability Icon.a1e13207.png";